import { Drawer } from '@mantine/core';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { LinkTrail } from 'src/Components/EntityLinks/LinkTrail';

import { Props } from './AnimatedRoutedDrawer.types';

const AnimatedRoutedDrawer = ({ children, title, to }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(location.state?.disableAnimation);
  const hubspotOriginalStyle = useRef('');

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const onDrawerClose = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => {
      if (to) {
        navigate(to, { replace: true });
      } else {
        navigate(-1);
      }
    }, 200);
  }, [navigate, to]);

  useEffect(() => {
    const hubspotContainer = document.getElementById('hubspot-messages-iframe-container');
    if (hubspotContainer) {
      hubspotOriginalStyle.current = hubspotContainer.style.cssText;
    }

    return () => {
      const container = document.getElementById('hubspot-messages-iframe-container');
      if (container) {
        container.style.cssText = hubspotOriginalStyle.current;
      }
    };
  }, []);

  useEffect(() => {
    const hubspotContainer = document.getElementById('hubspot-messages-iframe-container');
    if (hubspotContainer) {
      if (isOpen) {
        hubspotContainer.style.cssText = '';
      } else {
        hubspotContainer.style.cssText = hubspotOriginalStyle.current;
      }
    }
  }, [isOpen]);

  return (
    <Drawer
      position="right"
      opened={isOpen}
      onClose={onDrawerClose}
      size={'lg'}
      withCloseButton
      title={title}
      padding={20}
      // Never taller than the visible viewport: on Chrome Android 100% includes the URL bar,
      // which hid the bottom of long forms (and their submit button).
      styles={{ content: { maxHeight: '100dvh' } }}
      transitionProps={{
        duration: location.state?.disableAnimation ? 0 : 200,
        timingFunction: location.state?.disableAnimation ? 'none' : 'ease',
      }}
    >
      <LinkTrail />
      {children?.({ onClose: onDrawerClose })}
    </Drawer>
  );
};

export default AnimatedRoutedDrawer;
